import { css } from '@emotion/react';
import { ScheduleRequestSource } from '@weave/schema-gen-ts/dist/schemas/schedule/settings/v2/settings.pb';
import { useTranslation } from '@frontend/i18n';
import { getBookingSiteUrl } from '@frontend/schedule-helpers';
import { theme } from '@frontend/theme';
import { Tabs } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';
import { GoogleAccountContent } from './GoogleBusinessProfileContent/GoogleAccountContent';
import { bookingSiteSetupTrackingIds } from './trackingIds';
import { WebsiteTabContent } from './WebsiteTabContent';

enum TabEnum {
  GoogleAccount = 'google-account',
  Website = 'website',
}

type BookingSiteLinksProps = {
  isAccordionContent?: boolean;
};

export const BookingSiteLinks = ({ isAccordionContent = true }: BookingSiteLinksProps) => {
  const { t } = useTranslation('schedule-settings');
  const { selectedLocationIds, isMultiLocation, getOnlineSchedulingReadyLocationIds } = useSchedulingLocationInfo();
  const locationId = selectedLocationIds[0];

  // NOTE: Google Account tab is rendered only for single location.
  // For multi-location, as of now, we don't have a decision made on it's implementation. This needs to be updated later.
  const bookingSiteUrlForGoogleAccount = getBookingSiteUrl(locationId, ScheduleRequestSource.GOOGLE_BUSINESS_PROFILE);
  const shouldRenderGoogleAccount = getOnlineSchedulingReadyLocationIds().length > 0 && !isMultiLocation;

  return (
    <section css={containerStyle(isAccordionContent)}>
      <Tabs initialTab={shouldRenderGoogleAccount ? TabEnum.GoogleAccount : TabEnum.Website}>
        <Tabs.Bar>
          {shouldRenderGoogleAccount && (
            <Tabs.Tab id={TabEnum.GoogleAccount} trackingId={bookingSiteSetupTrackingIds.googleAccountTab}>
              {t('Google Account')}
            </Tabs.Tab>
          )}
          <Tabs.Tab id={TabEnum.Website}>{t('Website')}</Tabs.Tab>
        </Tabs.Bar>
        {shouldRenderGoogleAccount && (
          <Tabs.Panel controller={TabEnum.GoogleAccount}>
            <GoogleAccountContent locationId={locationId} bookingSiteURL={bookingSiteUrlForGoogleAccount} />
          </Tabs.Panel>
        )}
        <Tabs.Panel controller={TabEnum.Website}>
          <WebsiteTabContent />
        </Tabs.Panel>
      </Tabs>
    </section>
  );
};

const containerStyle = (isAccordionContent: boolean) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    background: theme.colors.white,
    padding: theme.spacing(2, 3, 5, 3),
    borderRadius: isAccordionContent ? 0 : theme.borderRadius.medium,
    maxWidth: 700,
  });
